import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, AlertTriangle, Package } from 'lucide-react';
import { format } from 'date-fns';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileWarehouseHoldsPage() {
  const navigate = useNavigate();
  const [holds, setHolds] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHolds = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/warehouse/holds`);
      setHolds(res.data || []);
    } catch (err) {
      console.error('Failed to fetch holds:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchHolds();
  }, [fetchHolds]);

  if (loading) {
    return (
      <div className="mobile-page">
        <div className="mobile-loading"><div className="mobile-spinner" /></div>
      </div>
    );
  }

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate(-1)}>
        <ArrowLeft size={18} /> Back
      </button>

      <div className="mobile-page-title" style={{ marginBottom: 16 }}>Holds</div>

      <div className="mobile-kpi-row" style={{ marginBottom: 16 }}>
        <div className="mobile-kpi-card red">
          <div className="mobile-kpi-label">Active Holds</div>
          <div className="mobile-kpi-value">{holds.filter(h => h.status === 'on_hold').length}</div>
        </div>
        <div className="mobile-kpi-card green">
          <div className="mobile-kpi-label">Released</div>
          <div className="mobile-kpi-value">{holds.filter(h => h.status === 'released').length}</div>
        </div>
      </div>

      {holds.length === 0 ? (
        <div className="mobile-empty-state">
          <AlertTriangle />
          <p>No holds found</p>
        </div>
      ) : (
        holds.map((hold) => (
          <div key={hold.hold_id} className="mobile-hold-card">
            <div className="mobile-hold-card-header">
              <div>
                <div style={{ fontWeight: 600, fontSize: 15, color: '#1c1c1e' }}>{hold.lp_number}</div>
                <div style={{ fontSize: 13, color: '#636366' }}>{hold.item_name || 'N/A'}</div>
              </div>
              <span className={`mobile-status-badge ${hold.status === 'on_hold' ? 'on_hold' : 'in_production'}`}>
                {hold.status}
              </span>
            </div>
            <div style={{ fontSize: 13, color: '#8e8e93', marginTop: 6 }}>
              <div><strong>Lot:</strong> {hold.lot_number || 'N/A'}</div>
              <div><strong>Qty:</strong> {hold.quantity_held || 0} {hold.uom || 'lbs'}</div>
              <div><strong>Reason:</strong> {hold.reason || 'N/A'}</div>
              <div><strong>Date:</strong> {hold.hold_date ? format(new Date(hold.hold_date), 'MMM d, yyyy') : 'N/A'}</div>
              <div><strong>By:</strong> {hold.held_by || 'N/A'}</div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
